import { useAppContext } from 'common/context/app-context'

export const useAppContextServiceInfo = () => {
  const { serviceInfoCtx } = useAppContext()
  return { ...serviceInfoCtx }
}
